import { ResponseMessageWithInternalStatus } from "../dto/response-message-with-internal-status.dto";

export interface TipoActividad {
  id: number;
  orden: number;
  descripcion: string;
}

export interface tipoActividades {
    actividades: TipoActividad[];
}

export interface TipoActividadesState {
  actividades: TipoActividad[];
  error: boolean;
  debugMessage?: any;
}

export interface ObtenerActividadesRequest {
  empresa: {
    id: number
  }
}

export interface ObtenerActividadesResponse extends ResponseMessageWithInternalStatus{
  actividades: {
    id: number,
    descripcion: string,
    orden: number
  }[]
}

export const initialActividadState: TipoActividadesState = {
  actividades: [],
  error: false,
  debugMessage: null
};
